module.exports = __webpack_public_path__ + "media/images/icon-star-2f676527e7177cba8fc35b5b937abf62.svg";